goog.provide("shadow.js.shim.module$$mui$material$Slider");
goog.provide("module$shadow_js_shim_module$$mui$material$Slider");
shadow.js.shim.module$$mui$material$Slider = shadow.js.nativeProvides["@mui/material/Slider"] = shadow$bridge("@mui/material/Slider");
module$shadow_js_shim_module$$mui$material$Slider.default = shadow.js.shim.module$$mui$material$Slider;
